import { BodyText, FlexRow } from '@make-software/cspr-design';
import styled from 'styled-components';

export const Container = styled(FlexRow)`
  padding: 16px 0;
`;

export const TokenAmount = styled(BodyText)(({ theme }) => theme.withMedia({ fontSize: '28px', lineHeight: '40px' }));
